// extracted by mini-css-extract-plugin
export var numpadContainer = "_rt-1";
export var phoneButton = "_rt-0";